import React, { useState, useEffect, useReducer } from "react";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import LoginIcon from "@mui/icons-material/Login";
import BackgroundImage from "../../images/login-background.jpg";
import {
  TextField,
  Grid,
  Button,
  CircularProgress,
  InputAdornment,
  Paper,
  Container,
} from "@mui/material";
import { Box } from "@mui/system";
import { loginWithEmail, microsoftLogin } from "../../actions/auth";
import { forgetPassword, resetPassword } from "../../api/auth";
import { handleAxiosError } from "../../config/action-config";
import { showAlert } from "../../actions/alert";
import {
  AccountCircle,
  Lock,
  Window as WindowIcon,
  Email,
} from "@mui/icons-material";
import { makeStyles } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  textfeild: {
    "& .MuiFilledInput-root": {
      background: "rgb(232, 241, 250)",
    },
  },
  paperContainer: {
    background: `url(${BackgroundImage})`,
    // backgroundImage: 'linear-gradient(90deg, #1b58af 0%, #2a95f7 100%)',
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    width: "100%",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0px",
    padding: "0px",
    borderImageSource: "linear-gradient(to right, #92add3, #a1d0fb)",
  },
  /*loginMicrosoftButton: {
    textAlign: 'center',
    position: 'relative',
    padding: '10px 20px',
    color: '#08469d',
    borderRadius: '6px',
    backgroundImage: 'linear-gradient(to right, #cddaeb , #d4eafd)',
    float: 'left',
    fontSize: '10px !important',
    "&:before": {
      border: "5px solid !important",
      borderImageSlice: 1,
      borderImageSource: 'linear-gradient(to right, #92add3, #a1d0fb) !important',
    }
  },*/
  notchedOutline: {
    borderWidth: "1px !important",
    borderColor: "#08459c !important",
  },
}));

const initReducerState = { dialogOpen: false, step: 0, resetLoader: false };

const localReducer = (state, action) => {
  switch (action.type) {
    case "OPEN_FORGET_PASSWORD":
      return { ...state, dialogOpen: true, step: state.step || 1 };
    case "CLOSE_FORGET_PASSWORD":
      return { ...state, dialogOpen: false };
    case "SEND_RESET_REQUEST":
      return { ...state, step: 2 };
    case "FINAL_CLOSE":
      return initReducerState;
    default:
      return state;
  }
};

export default function Login({ loggedIn }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [localState, localDispatch] = useReducer(
    localReducer,
    initReducerState
  );

  const [data, setData] = useState({ email: "", password: "" });
  const onInputChange = (e) => {
    setData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  // const onFormSubmit = (e) => {
  //   e.preventDefault();
  //   dispatch(loginWithEmail(data));
  // };
  const onFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Set loading state to true

    try {
      await dispatch(loginWithEmail(data));
      // Handle successful login
    } catch (error) {
      setLoading(false);
      // Handle login error
    } finally {
      setLoading(false); // Set loading state to false
    }
  };

  const handleMicrosoftLogin = () => {
    dispatch(microsoftLogin());
  };

  return loggedIn ? (
    <Navigate to="/" replace />
  ) : (
    <Paper className={classes.paperContainer}>
      <style>{`
        body {
          margin: 0px;
          padding: 0px;
        }
      `}</style>
      <Container component="main" maxWidth="xs">
        <Box>
          <Paper
            style={{
              padding: 20,
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              verticalAlign: "middle",
              boxShadow: "4px 4px 4px 4px rgba(0, 0, 0, 0.25)",
              borderRadius: "20px",
            }}
          >
            <div className="text-left">
              <h3>Login</h3>
              <br />
            </div>
            {/* <Box
              component="img"
              className="header-logo"
              alt="The house from the offer."
              src="https://actpipe.vastedge.com/apps/act_pipe_prod/r/100/files/static/v4/logo-ACT.png"
            /> */}
            <form onSubmit={onFormSubmit}>
              <Grid container direction="column" spacing={2}>
                <Grid item>
                  <TextField
                    variant="outlined"
                    className={classes.textfeild}
                    type="email"
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Email Address"
                    name="email"
                    value={data.email}
                    onChange={onInputChange}
                    InputProps={{
                      classes: {
                        notchedOutline: classes.notchedOutline,
                      },
                      startAdornment: (
                        <InputAdornment
                          sx={{ color: "#08469d" }}
                          position="start"
                        >
                          <Email />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item>
                  <TextField
                    variant="outlined"
                    className={classes.textfeild}
                    type="password"
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="Password"
                    id="password"
                    value={data.password}
                    onChange={onInputChange}
                    InputProps={{
                      classes: {
                        notchedOutline: classes.notchedOutline,
                      },
                      startAdornment: (
                        <InputAdornment
                          sx={{ color: "#08469d" }}
                          position="start"
                        >
                          <Lock />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                {/* <br /> */}

                <Grid item xs={12} md={12} lg={12}>
                  <Box display="flex" sx={{ justifyContent: "space-between" }}>
                    {/* {isVastEdgeEmail(data.email) ? (
                      <Grid item xs={7} md={7} lg={7}>
                        <Button
                          sx={{
                            fontSize: "12px !important",
                            textTransform: "capitalize",
                          }}
                          className="loginMicrosoftButton"
                          fullWidth
                          onClick={handleMicrosoftLogin}
                        >
                          <WindowIcon sx={{ mr: 2 }} /> Sign In With Microsoft
                        </Button>
                      </Grid>
                    ) : ( */}
                    <Grid item xs={7} md={7} lg={7}></Grid>
                    {/* )} */}
                    <Grid item xs={4} md={4} lg={4} textAlign="right">
                      <Button
                        type="submit"
                        variant="contained"
                        sx={{ fontSize: "12px", textTransform: "capitalize" }}
                        disabled={loading} // Disable button when loading is true
                      >
                        Sign In &nbsp;
                        <LoginIcon />
                      </Button>
                    </Grid>
                  </Box>
                </Grid>

                <Grid item xs={12} md={12} lg={12} textAlign="right">
                  <Button
                    variant="text"
                    onClick={() => {
                      localDispatch({ type: "OPEN_FORGET_PASSWORD" });
                    }}
                    sx={{ fontSize: "12px", textTransform: "capitalize" }}
                  >
                    <u>Forgot Password?</u>
                  </Button>
                </Grid>
              </Grid>
            </form>
            <ForgetPasswordDialog
              open={localState.dialogOpen}
              localState={localState}
              localDispatch={localDispatch}
            />
          </Paper>
        </Box>
      </Container>
    </Paper>
  );
}
function isVastEdgeEmail(email) {
  return /@vastedge\.com$/.test(email);
}
function ForgetPasswordDialog({ localState, localDispatch }) {
  const [email, setEmail] = useState("");
  const [resetData, setResetData] = useState({ otp: "", newPassword: "" });
  const [showLoader, setShowLoader] = useState(false);
  const dispatch = useDispatch();

  const { step } = localState;

  useEffect(() => {
    if (!localState.dialogOpen) {
      setShowLoader(false);
      setEmail("");
      setResetData({ otp: "", newPassword: "" });
    }
  }, [localState]);

  const onCancel = () => {
    localDispatch({ type: "CLOSE_FORGET_PASSWORD" });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      if (step === 1) {
        await forgetPassword(email);
        localDispatch({ type: "SEND_RESET_REQUEST" });
      } else {
        const { data } = await resetPassword(
          email,
          resetData.otp,
          resetData.newPassword
        );
        localDispatch({ type: "FINAL_CLOSE" });
        dispatch(showAlert(data.msg));
      }
    } catch (error) {
      localDispatch({ type: "FINAL_CLOSE" });
      handleAxiosError(error, dispatch);
    }
  };

  return (
    <Dialog
      open={localState.dialogOpen}
      onClose={() => {}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Box
        display="flex"
        sx={{ justifyContent: "space-between", pr: 2, alignItems: "center" }}
      >
        <DialogTitle id="alert-dialog-title">
          {step === 1 ? "Enter Email" : "Enter OTP and New Password"}
        </DialogTitle>
        <Box>{showLoader ? <CircularProgress size="2rem" /> : <></>}</Box>
      </Box>
      <form onSubmit={onSubmit}>
        <DialogContent>
          <Grid
            container
            rowSpacing={2}
            sx={{ maxWidth: "500px", minWidth: "min(400px, 90vw)", py: 1 }}
          >
            <Grid item xs={12} md={12}>
              <TextField
                variant="outlined"
                fullWidth
                label="Email"
                type="email"
                name="email"
                required
                value={email}
                disabled={step === 2}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
            </Grid>
            {step === 2 ? (
              <>
                <Grid item xs={12} md={12}>
                  <TextField
                    variant="outlined"
                    type="number"
                    fullWidth
                    label="Enter OTP"
                    name="otp"
                    value={resetData.otp}
                    required={step === 2}
                    onChange={(e) => {
                      setResetData((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value,
                      }));
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <TextField
                    variant="outlined"
                    type="password"
                    fullWidth
                    label="New Password"
                    name="newPassword"
                    value={resetData.newPassword}
                    required={step === 2}
                    onChange={(e) => {
                      setResetData((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value,
                      }));
                    }}
                  />
                </Grid>
              </>
            ) : (
              <></>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={onCancel}
            className="cancel-button"
          >
            Cancel
          </Button>
          <Button type="submit" variant="contained" className="blue-button">
            Submit
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
